module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescirp3-67c37e8fa45656d0b972d3b5748500d3.jpg";